import { render, staticRenderFns } from "./LoginHero.vue?vue&type=template&id=667e50ca&scoped=true&"
import script from "./LoginHero.vue?vue&type=script&lang=ts&"
export * from "./LoginHero.vue?vue&type=script&lang=ts&"
import style0 from "./LoginHero.vue?vue&type=style&index=0&id=667e50ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e50ca",
  null
  
)

export default component.exports